import { Base, withBreakpointManager } from '@studiometa/js-toolkit';
import ParallaxImageMobile from './ParallaxImageMobile.js';
import ParallaxImageDesktopHorizontal from './ParallaxImageDesktopHorizontal.js';

/**
 * ParallaxImage component
 */
export default class ParallaxImageHorizontal extends withBreakpointManager(Base, [
  ['xxs xs s', ParallaxImageMobile],
  ['m l xl xxl', ParallaxImageDesktopHorizontal],
]) {
  static config = {
    name: 'ParallaxImage',
  };
}
